runOnLoad "ModifySubscribers", [ "new", "create", "edit", "update" ], ->

  StylesheetForm.setup()
  CloudCustomFieldManager.setup()

runOnLoad "ModifySubscribers", [ "show" ], ->

  ClipboardButton.setup()
